import React, { useState } from "react";
import { Check, ChevronDown, ChevronUp } from "lucide-react";

/** Render section names and included features exactly as delivered by the Live catalog API. */
export default function YasharalLiveFeatureSections({ sections = {}, compact = false }) {
  const [openSections, setOpenSections] = useState({});
  return (
    <div className={compact ? "space-y-2" : "mt-4 space-y-2 border-t border-slate-800 pt-4"}>
      {Object.entries(sections || {}).map(([section, features]) => {
        const open = Boolean(openSections[section]);
        return (
          <div key={section} className="overflow-hidden rounded-xl border border-slate-800 bg-[#0b0d11]">
            <button type="button"
              onClick={() => setOpenSections(current => ({ ...current, [section]: !current[section] }))}
              className="flex w-full min-w-0 items-center justify-between gap-3 px-3 py-3 text-left"
              aria-expanded={open}>
              <span className="min-w-0 break-words text-[11px] font-bold uppercase tracking-[0.12em] text-[#9dc1ff]">{section}</span>
              {open ? <ChevronUp className="h-4 w-4 flex-shrink-0 text-slate-400" /> : <ChevronDown className="h-4 w-4 flex-shrink-0 text-slate-400" />}
            </button>
            {open && (
              <div className="border-t border-slate-800 px-3 py-3">
                {Array.isArray(features) && features.length ? (
                  <ul className="space-y-2">
                    {features.map((feature, index) => (
                      <li key={index} className="flex gap-2 text-sm leading-relaxed text-slate-300">
                        <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#9dc1ff]" />
                        <span className="min-w-0 break-words">{feature}</span>
                      </li>
                    ))}
                  </ul>
                ) : <p className="text-xs leading-relaxed text-slate-500">No additional features in this category at this tier.</p>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
